import { PhaseChangeType } from '@piccolohealth/pbs-common';
import React from 'react';
import { FormStack } from '../../../../components/forms/FormStack';
import { HookedColorPicker } from '../../../../components/forms/HookedColorPicker';
import { HookedFormField } from '../../../../components/forms/HookedFormField';
import { HookedInput } from '../../../../components/forms/HookedInput';
import { HookedSegmentGroup } from '../../../../components/forms/HookedSegmentGroup';
import { HookedSingleDatepicker } from '../../../../components/forms/HookedSingleDatepicker';

export const PhaseChangeLineForm = () => {
  return (
    <FormStack w='full'>
      <FormStack>
        <HookedFormField
          name='name'
          label='Name'
          helperText='What do you want to call the phase change line?'
        >
          <HookedInput
            name='name'
            placeholder='Eg: Physical aggresson vs Self Injurious'
            size='sm'
          />
        </HookedFormField>
      </FormStack>
      <FormStack>
        <HookedFormField
          name='timestamp'
          label='Timestamp'
          helperText='When did the phase change occur?'
        >
          <HookedSingleDatepicker name='timestamp' size='sm' />
        </HookedFormField>
      </FormStack>
      <FormStack orientation='horizontal'>
        <HookedFormField name='type' label='Type' helperText='What type of phase change is this?'>
          <HookedSegmentGroup
            name='type'
            options={[
              {
                label: 'Minor',
                value: PhaseChangeType.Minor,
              },
              {
                label: 'Major',
                value: PhaseChangeType.Major,
              },
            ]}
            size='sm'
          />
        </HookedFormField>
        <HookedFormField name='color' label='Color' w='fit-content'>
          <HookedColorPicker mode='hex' name='color' />
        </HookedFormField>
      </FormStack>
    </FormStack>
  );
};
